import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as GoogleCalenderIcon } from 'assets/svgs/google-calendar.svg';
import { ReactComponent as OutlookCalenderIcon } from 'assets/svgs/outlook.svg';
import { BlueGhostButton } from 'components/organisms/timesheets/common/style';

const Button = styled(BlueGhostButton)`
  display: flex;
  svg {
    height: var(--layout-01);
    width: var(--layout-01);
  }
  gap: var(--spacing-03);
`;

export const AddToCalendar = ({ onclick }) => {
  return (
    <Button data-cy="timesheets.buttons.calendar-integration" onClick={onclick}>
      <GoogleCalenderIcon />
      <FormattedMessage id="timesheets.buttons.calendar-integration" />
    </Button>
  );
};

export const AddToOutlookCalendar = ({ onclick }) => {
  return (
    <Button data-cy="timesheets.buttons.calendar-integration" onClick={onclick}>
      <OutlookCalenderIcon />
      <FormattedMessage id="timesheets.buttons.calendar-integration" />
    </Button>
  );
};
